import React, { Component } from 'react'
import DataTable from 'components/data-table';
import { header } from 'constants/table';
import { API_URL } from 'constants/config';
import { Input, DropDown, DatePicker } from 'components/tt-forms/common';
import { RowItemDanhMucTongHopThanhTra } from 'modules/thanh-tra-trung/datatable';
import { ThanhTra } from 'api';
import moment from 'moment';
import {isEmpty , get} from 'lodash';
import { downloadExcel } from 'constants/downloadExcel';

export default class DanhMucTongHopThanhTra extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      soQuyetDinh: '',
      namThanhTra: '',
      loading: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      denNgay: '',
      tuNgay: '',
      data: [],
      type: '',
      selectListItem: [],
      listNamThanhTra: [],
      listloaiHinhThanhTra: [
        {
            giaTri: "THANH_TRA",
            ten: "Thanh tra"
        },
        {
            giaTri: "KIEM_TRA",
            ten: "Kiểm tra"
        }
      ],
    }
  }

  async componentDidMount() {
    await this.checkNamThanhTraXuLy();
    this.getDSCuocThanhTra();
    this.getDonVi();
    // this.getLoaiHinhThanhTra();
    this.getPhanLoaiHinhThucCTT();
    this.getNamThanhTraList();
  }

  // getLoaiHinhThanhTra() {
  //   ThanhTra.actions.getLoaiHinhThanhTra.request().then(res => {
  //     if (!isEmpty(res.data)) {
  //       const listloaiHinhThanhTra = get(res, 'data') || [];
  //       this.setState({ listloaiHinhThanhTra });
  //     } else {
  //       this.setState({ listloaiHinhThanhTra: [] });
  //     }
  //   });
  // }

  async checkNamThanhTraXuLy() {
    await ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(async res => {
      if (!isEmpty(res.data)) {
        await this.setState({
          namThanhTra: get(res, 'data.namThanhTra')
        });
      }
    });
  }

  getPhanLoaiHinhThucCTT() {
    ThanhTra.actions.nhomHinhThucCuocThanhTraPhanLoai.request().then(res => {
      if (!isEmpty(res.data)) {
        const listphanLoai = get(res, 'data') || [];
        this.setState({ listphanLoai });
      } else {
        this.setState({ listphanLoai: [] });
      }
    });
  }

  getNamThanhTraList() {
    ThanhTra.actions.getNamThanhTra.request().then(res => {
      if (!isEmpty(res.data)) {
        this.setState({
          listNamThanhTra: res.data
        });
      }
    });
  }

  getDSCuocThanhTra() {
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      isTatCaDonVi: true
    };

    if (this.state.tenDoiTuongThanhTra) {
      params.tenDoiTuongThanhTra = this.state.tenDoiTuongThanhTra;
    }

    if (this.state.phanLoai) {
      params.phanLoai = this.state.phanLoai;
    }

    if (this.state.soQuyetDinh) {
      params.soQuyetDinh = this.state.soQuyetDinh;
    }

    if (this.state.loaiHinhThanhTra) {
      params.loaiKeHoach = this.state.loaiHinhThanhTra;
    }

    if (this.state.quyetDinhPheDuyetKHTT) {
      params.quyetDinhPheDuyetKHTT = this.state.quyetDinhPheDuyetKHTT;
    }

    if (this.state.tienDoThanhTra) {
      params.tienDoThanhTra = this.state.tienDoThanhTra;
    }

    if (this.state.tuNgay) {
      params.tuNgay = moment(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }

    if (this.state.denNgay) {
      params.denNgay = moment(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }

    if (this.state.soKetLuanThanhTra) {
      params.soKetLuanThanhTra = this.state.soKetLuanThanhTra;
    }

    if (this.state.soQuyetDinhXL) {
      params.soQuyetDinhXL = this.state.soQuyetDinhXL;
    }

    if (!isEmpty(this.state.namThanhTra)) {
      params.namThanhTra = this.state.namThanhTra;
    }

    if (!isEmpty(this.state.selectListItem)) {
      const selectListItem = this.state.selectListItem || [];
      const arrDonVis = selectListItem.map(item => get(item, 'coQuanQuanLyId'));
      params.donViIds = arrDonVis.join(',');
    }
    this.setState({
      tableLoading: true
    });
    ThanhTra.actions.getCuocThanhTra.request(null, params).then(res => {
      if (!isEmpty(res.data._embedded)) {

        const data = get(res, 'data._embedded.cuocThanhTras') || [];
        const pageData = get(res, 'data.page');
        const tableLoading = false;
        const search = false;
        this.setState({
          data,
          pageData,
          tableLoading,
          search
        });
      } else {
        const tableLoading = false;
        const search = false;
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading,
          search
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      type: nextProps.type
    }, () => {
      this.getDSCuocThanhTra();
    })
  }

  handleSearch (e) {
    e.preventDefault();
    this.getDSCuocThanhTra();
  }

  onChange (name, e) {
    if (name === 'donViThanhTra') {
      const {dataListDonVi} = this.state;
      const selectListItem = [...this.state.selectListItem];
      const checkItem = selectListItem.findIndex(item => Number(item.coQuanQuanLyId) === Number(e.target.value));
      if (checkItem === -1){
        const selectItem = dataListDonVi.find(item => Number(item.coQuanQuanLyId) === Number(e.target.value));
        selectListItem.push(selectItem);
      }
      this.setState({
        selectListItem
      });
    } else {
      this.setState({
        [name]: e.target.value
      });
    }
  }

  handleExport () {
    const name = 'danh-muc-cuoc-thanh-tra-kiem-tra-cua-cac-don-vi';
    const apiUrl = '/cuocThanhTras/export-excel'
    const donViIds = this.state.selectListItem.map(item => item.coQuanQuanLyId).join(',');
    // eslint-disable-next-line no-useless-concat
    const URL = `${String(API_URL)}/${apiUrl}` + "?soQuyetDinh=" + this.state.soQuyetDinh
    + "&tuNgay=" + (this.state.tuNgay ? moment(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
    + "&denNgay=" + (this.state.denNgay ? moment(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
    + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '')
    + "&tenDoiTuongThanhTra=" + (this.state.tenDoiTuongThanhTra ? this.state.tenDoiTuongThanhTra : '')
    + "&donViIds=" + (donViIds ? donViIds : [])
    + "&phanLoai=" + (this.state.phanLoai ? this.state.phanLoai : '')
    + "&loaiKeHoach=" + (this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : '')
    + "&tienDoThanhTra=" + (this.state.tienDoThanhTra ? this.state.tienDoThanhTra : '')
    + "&soKetLuanThanhTra=" + (this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '')
    + "&soQuyetDinhXL=" + (this.state.soQuyetDinhXL ? this.state.soQuyetDinhXL : '')
    + "&isTatCaDonVi=true"
  ;

    downloadExcel(URL, name, true);
  }

  removeDonVi (index) {
    const selectListItem = [...this.state.selectListItem];
    selectListItem.splice(index, 1);
    this.setState({
      selectListItem
    });
  }

  getDonVi() {
    ThanhTra.actions.getKHTTDonVi.request().then(res => {
      if (!isEmpty(res.data._embedded)) {
        const data = get(res, 'data._embedded.coQuanQuanLies');
        this.setState({
          dataListDonVi: data
        });
      } else {
        this.setState({dataListDonVi: []})
      }
    });
  }

  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: page.selected
      }
    }, () => {
      this.getDSCuocThanhTra();
    })
  }

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        size,
        number: 0
      }
    }, () => {
      this.getDSCuocThanhTra();
    });
  }

  handleChangeDate (name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  render() {
    return (
      <div className="center reception-container" ref="dskhtt">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-thanh-tra"></i>DANH MỤC TỔNG HỢP CUỘC THANH TRA, KIỂM TRA CỦA CÁC ĐƠN VỊ</p>
          </div>
        </div>
        <div className="bottom-content">
          <div className='wrap-block pl15 pr15 pt20'>
            <form onSubmit={this.handleSearch.bind(this)}>
              <div className='row pl10 pr10'>
                <div className='col-83 no-gutter'>
                  <Input className='col-60' label='Đối tượng thanh tra/kiểm tra' placeholder='Nhập tên đối tượng thanh tra, kiểm tra tìm kiếm...' value={this.state.tenDoiTuongThanhTra} onChange={this.onChange.bind(this, 'tenDoiTuongThanhTra')} name='tenDoiTuongThanhTra'/>
                  <DropDown className='col-20 mb18' label='Loại hình thanh tra, kiểm tra' options={this.state.listloaiHinhThanhTra} keyName="giaTri" valueName="ten" selectedValue={this.state.loaiHinhThanhTra} onChange={this.onChange.bind(this, 'loaiHinhThanhTra')} placeholder/>
                  <Input className='col-20' label='Số quyết định' placeholder='Nhập...' value={this.state.soQuyetDinh} onChange={this.onChange.bind(this, 'soQuyetDinh')} name='soQuyetDinh' maxLength={255}/>
                </div>
                <div className='col-16 mb0-18 search-thanh-tra'>
                  <button className='btn-green' >
                    <i className='tt-search'></i>Tìm kiếm
                  </button>
                </div>
                <div className='col-83 no-gutter'>
                  <DatePicker className="col-20" label='Quyết định ra từ ngày' bindValidator={this} channel="formTaoDon" onChange={ this.handleChangeDate.bind(this, 'tuNgay')} value={this.state.tuNgay} name='tuNgay' />
                  <DatePicker className="col-20" label='Đến ngày' bindVaidator={this} channel="formTaoDon" onChange={ this.handleChangeDate.bind(this, 'denNgay')} value={this.state.denNgay} name='denNgay' />
                  <Input className='col-20' label='Số kết luận thanh tra, kiểm tra' placeholder='Nhập...' value={this.state.soKetLuanThanhTra} onChange={this.onChange.bind(this, 'soKetLuanThanhTra')} name='soKetLuanThanhTra' maxLength={255}/>
                  <Input className='col-20' label='Số quyết định XL' placeholder='Nhập...' value={this.state.soQuyetDinhXL} onChange={this.onChange.bind(this, 'soQuyetDinhXL')} name='soQuyetDinhXL' maxLength={255}/>
                  <DropDown className='col-20' label='Phân loại' options={this.state.listphanLoai} keyName="giaTri" valueName="ten" selectedValue={this.state.phanLoai} onChange={this.onChange.bind(this, 'phanLoai')} placeholder/>
                </div>
                <div className='wrap-tt-dvph col-83 no-gutter'>
                <DropDown className="col-20 mb18" label="Năm thanh tra, kiểm tra" options={this.state.listNamThanhTra} keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} placeholder/>
                  <DropDown className='col-20 mb18' label='Đơn vị' options={this.state.dataListDonVi} keyName="coQuanQuanLyId" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'donViThanhTra')} placeholder/>
                  <div className='col-60 mb18'>
                    <div className='ds-tt-dvph'>
                      {
                        this.state.selectListItem.map((item,index) => (
                          <div className="tt-dvph-item" key={index}>
                            <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, index)}>×</span>
                            <span className="tt-dvph-value">{item.ten}</span>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div className='row'>
              <span className="line-border"></span>
            </div>
          </div>
          {/* Ẩn xuất Excel */}
          <DataTable
            header={header.thanhTraTrung.DMTHCTTCDV}
            handleExport={this.handleExport.bind(this)}
            dataList={this.state.data}
            exporttext="Xuất Excel"
            thanhTra={true}
            hideButtonExport={false}
            pageData={this.state.pageData}
            parent={this}
            search
            tableLoading={this.state.tableLoading}>
            <RowItemDanhMucTongHopThanhTra/>
          </DataTable>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/DanhMucTongHopThanhTra.jsx